import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import AddCircleOutline from 'material-ui/svg-icons/content/add-circle-outline'
import RemoveCircleOutline from 'material-ui/svg-icons/content/remove-circle-outline'
import SearchBar from '../../sitewide/Filter/SearchBar'
import PatientNamesList from './PatientNamesList'
import Button from '../../sitewide/Button'

import css from './styles.css'

const EditView = props => (
  <div className={css.container}>
    <h2 className={css.title}>{props.isEdit ? 'Edit' : 'Create'} Group</h2>
    <label
      htmlFor="group-name"
      className={css.inputLabel}
    >
      Name
      <input
        placeholder='e.g. "Bad Brushers"'
        type="text"
        name="name"
        id="group-name"
        value={props.name}
        onChange={props.onChange}
        className={css.input}
      />
    </label>
    <label
      htmlFor="group-description"
      className={css.inputLabel}
    >
      Description
      <input
        placeholder='e.g. "Patients who need brushing tips"'
        type="text"
        name="description"
        id="group-description"
        value={props.description}
        onChange={props.onChange}
        className={css.input}
      />
    </label>
    <div className={css.patientLists}>
      <div className={css.searchResults}>
        <h4>Add patients</h4>
        <SearchBar
          onChange={props.onChange}
          handleSearchParams={props.handleSearchParams}
          value={props.searchValue}
        />
        <PatientNamesList
          patients={props.searchResults}
          icon={<AddCircleOutline />}
          onClick={props.addToGroup}
        />
      </div>
      <div className={css.members}>
        <h4>Current members</h4>
        <PatientNamesList
          patients={props.membersToDisplay}
          icon={<RemoveCircleOutline />}
          onClick={props.removeFromGroup}
        />
      </div>
    </div>

    <div className={css.buttonsContainer}>
      {
        props.isEdit && (
          <Button buttonClass={'delete'} onClick={props.onDelete}>
            delete
          </Button>
        )
      }
      <Button buttonClass={'submit'} onClick={props.onSubmit}>
        submit
      </Button>
    </div>
  </div>
)

EditView.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  searchResults: PropTypes.array.isRequired,
  membersToDisplay: PropTypes.array.isRequired,
  addToGroup: PropTypes.func.isRequired,
  removeFromGroup: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  handleSearchParams: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default EditView



// WEBPACK FOOTER //
// ./src/components/PatientGroups/Edit/View.js